import { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { 
  Calendar, 
  CheckCircle2, 
  XCircle, 
  TrendingUp, 
  DollarSign, 
  Layers, 
  Filter,
  RefreshCw,
  Upload, FileCheck,
  ShieldAlert,
  X,
  Plus,
  Trash2,
  ShieldCheck
} from "lucide-react";

export default function ValidasiOmset() {
  // =========================
  // STATE MANAGEMENT
  // =========================
  const [dataOmset, setDataOmset] = useState([]);
  const [paymentMethods, setPaymentMethods] = useState([]); 
  const [loading, setLoading] = useState(true);
  const [startDate, setStartDate] = useState("2026-06-01");
  const [endDate, setEndDate] = useState("");
  const [statusFilter, setStatusFilter] = useState("All");
  const userName = localStorage.getItem("nama") || "User"; // Sesuaikan key localStorage Anda (misal: 'name' atau 'username')
const [isChecked, setIsChecked] = useState(false);

  // State Manajemen Modal Multi-Metode
  const [selectedRow, setSelectedRow] = useState(null);
  const [formSplits, setFormSplits] = useState([]); // Menampung array [{ metode: '', nominal: 0 }]
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Fetch Data Utama & Opsi Dropdown
  useEffect(() => {
    const fetchData = async () => {
      const kode_toko = localStorage.getItem("kode_toko");
         const id_sunfish = localStorage.getItem("id_sunfish");
      try {
        setLoading(true);
        const [resOmset, resMethods] = await Promise.all([
          axios.get("/api/sales/validate-payment", {
            params: { tanggal_awal: "2026-06-01", kode_customer: kode_toko, id_sunfish: id_sunfish }
          }),
          axios.get("/api/sales/payment-methods")
        ]);

        if (resOmset.data.success) {
          const mappedData = resOmset.data.data.map(item => {
            const defaultSplits = item.detail_pembayaran || [
              { metode: "CASH", nominal: Number(item.netto_pembayaran) || 0 }
            ];

            return {
              tanggal_penjualan: item.tanggal,
              qty: Number(item.qty),
              bruto: Number(item.bruto),
              potongan: Number(item.potongan),
              netto_penjualan: Number(item.netto_penjualan),
              cost_tiktok: Number(item.cost_tiktok || 0),
              detail_pembayaran: defaultSplits
            };
          });
          setDataOmset(mappedData);
        }

        if (resMethods.data.success) {
          setPaymentMethods(resMethods.data.data);
        } else {
          setPaymentMethods([{ name: "CASH" }, { name: "EDC BCA" }, { name: "EDC MANDIRI" }, { name: "QRIS" }]);
        }
      } catch (err) {
        console.error("Gagal mengambil data dari backend", err);
        setPaymentMethods([{ name: "CASH" }, { name: "EDC BCA" }, { name: "EDC MANDIRI" }, { name: "QRIS" }]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // =========================
  // AUTOMATIC VALIDATION & FILTERING
  // =========================
  const processedData = useMemo(() => {
    return dataOmset.map(item => {
      const totalTerbayar = item.detail_pembayaran.reduce((sum, p) => sum + Number(p.nominal) , 0);
      const isMatch = Number(item.netto_penjualan) + Number(item.cost_tiktok || 0) === totalTerbayar;

      return {
        ...item,
        total_pembayaran: totalTerbayar,
        is_valid: isMatch,
        status_label: isMatch ? "Sesuai" : "Belum Sesuai"
      };
    }).filter(item => {
      const matchStatus = statusFilter === "All" || item.status_label === statusFilter;
      const matchStart = !startDate || new Date(item.tanggal_penjualan) >= new Date(startDate);
      const matchEnd = !endDate || new Date(item.tanggal_penjualan) <= new Date(endDate);
      return matchStatus && matchStart && matchEnd;
    });
  }, [dataOmset, startDate, endDate, statusFilter]);

  // Ringkasan Akumulasi Atas
  const totals = useMemo(() => {
    return processedData.reduce(
      (acc, curr) => {
        acc.qty += Number(curr.qty);
        acc.bruto += Number(curr.bruto);
        acc.potongan += Number(curr.potongan);
        acc.netto_penjualan += Number(curr.netto_penjualan);
        acc.total_pembayaran += Number(curr.total_pembayaran);
        acc.cost_tiktok += Number(curr.cost_tiktok || 0);
        return acc;
      },
      { qty: 0, bruto: 0, potongan: 0, netto_penjualan: 0, total_pembayaran: 0, cost_tiktok: 0 }
    );
  }, [processedData]);

  // =========================
  // MODAL INTERACTION LOGIC
  // =========================
  const handleRowClick = (item) => {
    setSelectedRow(item);
    if (item.detail_pembayaran && item.detail_pembayaran.length > 0) {
      setFormSplits([...item.detail_pembayaran]);
    } else {
      setFormSplits([{ metode: "", nominal: item.netto_penjualan }]);
    }
  };

  const handleAddSplitRow = () => {
  setFormSplits([...formSplits, { metode: "", nominal: 0, file_bukti: null, nama_file_bukti: "" }]);
};

  // 💡 PERBAIKAN: Menghapus batas "formSplits.length > 1" agar baris terakhir pun bisa dihapus menjadi []
  const handleRemoveSplitRow = (index) => {
    const updated = formSplits.filter((_, i) => i !== index);
    setFormSplits(updated);
  };



const handleSplitChange = (index, field, value) => {
  const updated = formSplits.map((row, i) => {
    if (i === index) {
      if (field === "file_bukti") {
        const file = value;
        return { 
          ...row, 
          file_bukti: file, 
          nama_file_bukti: file ? file.name : "" 
        };
      }
      return { ...row, [field]: field === "nominal" ? Number(value) : value };
    }
    return row;
  });
  setFormSplits(updated);
};

  const currentFormTotal = useMemo(() => {
    return formSplits.reduce((sum, item) => sum + (Number(item.nominal) || 0), 0);
  }, [formSplits]);

 const handleSaveValidation = async (e) => {
  e.preventDefault();
  const kode_toko = localStorage.getItem("kode_toko");
  const id_sunfish = localStorage.getItem("id_sunfish");

  if (formSplits.length > 0) {
    const dynamicCheckEmpty = formSplits.some(item => !item.metode || item.nominal <= 0);
    if (dynamicCheckEmpty) {
      return alert("Harap isi semua baris metode pembayaran dan nominal dengan benar!");
    }
  }

  try {
    setIsSubmitting(true);

    // 💡 SOLUSI UTAMA: Gunakan FormData agar file bisa ikut terkirim ke server
    const formData = new FormData();
    formData.append("tanggal", selectedRow.tanggal_penjualan);
    formData.append("kode_customer", kode_toko);
    formData.append("id_sunfish", id_sunfish);
    
    // Kirim objek array splits dalam bentuk JSON String agar bisa di-parse backend
    formData.append("splits", JSON.stringify(formSplits));

    // Loop data formSplits untuk melampirkan berkas filenya
    formSplits.forEach((item, index) => {
      // Pastikan item.file berisi object File dari input type="file" (e.target.files[0])
      if (item.file_bukti) { 
        // Nama field disamakan dengan pola backend yaitu files[0], files[1], dst.
        formData.append(`files[${index}]`, item.file_bukti);
      }
    });

    // 💡 Kirim menggunakan formData, Axios otomatis mengatur header multipart/form-data
    await axios.post("/api/sales/save-validation-split", formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });

    setDataOmset(prev => prev.map(item => {
      if (item.tanggal_penjualan === selectedRow.tanggal_penjualan) {
        return {
          ...item,
          detail_pembayaran: formSplits
        };
      }
      return item;
    }));

    setSelectedRow(null);
    alert("Berhasil menyimpan data dan gambar bukti!");
  } catch (err) {
    console.error("Gagal menyimpan alokasi pecahan metode", err);
    alert("Terjadi gangguan simpan data.");
  } finally {
    setIsSubmitting(false);
  }
};

  return (
    <div className="p-6 min-h-screen bg-slate-50 text-slate-800 antialiased">
      
      {/* HEADER SECTION */}
      <div className="bg-white rounded-2xl border border-slate-200/80 shadow-xs p-6 mb-6">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
          <div>
            <div className="flex items-center gap-2">
              <h1 className="text-2xl font-bold text-slate-900">Validasi Rekonsiliasi Omset</h1>
              
            </div>
            <p className="text-sm text-slate-500 mt-1.5">
              Klik baris untuk memecah total pembayaran ke beberapa metode. Akumulasi harus pas dengan <strong>Netto Penjualan</strong>.
            </p>
          </div>

          {/* FILTERS */}
          <div className="flex flex-wrap items-center gap-3">
            <div className="h-10 border border-slate-200 rounded-xl px-3 flex items-center gap-2 bg-white text-sm font-medium">
              <Calendar size={16} className="text-slate-400" />
              <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} className="outline-none" />
              <span className="text-slate-400">s/d</span>
              <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} className="outline-none" />
            </div>

            <div className="h-10 border border-slate-200 rounded-xl px-3 flex items-center gap-2 bg-white text-sm font-medium">
              <Filter size={16} className="text-slate-400" />
              <select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)} className="outline-none bg-transparent cursor-pointer">
                <option value="All">Semua Status Kelayakan</option>
                <option value="Sesuai">Sesuai</option>
                <option value="Belum Sesuai">Belum Sesuai</option>
              </select>
            </div>
          </div>
        </div>
      </div>

     {/* SUMMARY CARDS */}
<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 mb-6">
  {/* Card 1: Total Volume */}
  <div className="bg-white border border-slate-200 rounded-xl p-4 flex items-center gap-3.5 shadow-xs">
    <div className="p-3 bg-slate-50 text-slate-600 rounded-xl flex-shrink-0">
      <Layers size={18} />
    </div>
    <div className="min-w-0">
      <p className="text-[10px] text-slate-400 font-bold uppercase tracking-wider truncate">Total Volume</p>
      <h3 className="text-xl font-bold text-slate-800 mt-0.5 truncate">
        {totals.qty.toLocaleString("id-ID")} <span className="text-xs font-normal text-slate-400">Pcs</span>
      </h3>
    </div>
  </div>

  {/* Card 2: Total Netto */}
  <div className="bg-white border border-slate-200 rounded-xl p-4 flex items-center gap-3.5 shadow-xs">
    <div className="p-3 bg-rose-50 text-rose-600 rounded-xl flex-shrink-0">
      <DollarSign size={18} />
    </div>
    <div className="min-w-0">
      <p className="text-[10px] text-rose-500 font-bold uppercase tracking-wider truncate">Total Netto Penjualan</p>
      <h3 className="text-xl font-bold text-slate-800 mt-0.5 truncate">Rp {totals.netto_penjualan.toLocaleString("id-ID")}</h3>
    </div>
  </div>

  {/* Card 3: Total Cost */}
  <div className="bg-white border border-slate-200 rounded-xl p-4 flex items-center gap-3.5 shadow-xs">
    <div className="p-3 bg-rose-50 text-rose-600 rounded-xl flex-shrink-0">
      <DollarSign size={18} />
    </div>
    <div className="min-w-0">
      <p className="text-[10px] text-rose-500 font-bold uppercase tracking-wider truncate">Total Cost Penjualan</p>
      <h3 className="text-xl font-bold text-slate-800 mt-0.5 truncate">Rp {totals.cost_tiktok.toLocaleString("id-ID")}</h3>
    </div>
  </div>

  {/* Card 4: Total Akumulasi Terbayar */}
  <div className="bg-white border border-indigo-100 bg-indigo-50/10 rounded-xl p-4 flex items-center gap-3.5 shadow-xs">
    <div className="p-3 bg-indigo-600 text-white rounded-xl flex-shrink-0">
      <TrendingUp size={18} />
    </div>
    <div className="min-w-0">
      <p className="text-[10px] text-indigo-600 font-bold uppercase tracking-wider truncate">Total Tervalidasi</p>
      <h3 className="text-xl font-black text-indigo-700 mt-0.5 truncate">Rp {totals.total_pembayaran.toLocaleString("id-ID")}</h3>
    </div>
  </div>

{/* 💡 CARD DINDAMIS KPI VALIDATOR */}
        {(() => {
          const totalItems = processedData.length;
          const validItems = processedData.filter(item => item.is_valid).length;
          const kpiPercentage = totalItems > 0 ? Math.round((validItems / totalItems) * 100) : 0;
          const isPerfect = kpiPercentage === 100;

          return (
            <div className={`border rounded-xl p-4 flex items-center gap-3.5 shadow-xs transition-all duration-300 bg-white ${
              isPerfect ? "border-emerald-100 bg-emerald-50/20" : "border-rose-200 bg-rose-50/30 ring-2 ring-rose-500/5"
            }`}>
              <div className={`p-3 text-white rounded-xl flex-shrink-0 ${isPerfect ? "bg-emerald-500" : "bg-rose-600"}`}>
                {isPerfect ? <ShieldCheck size={18} /> : <ShieldAlert size={18} />}
              </div>
              <div className="min-w-0 w-full">
                <p className={`text-[10px] font-bold uppercase tracking-wider truncate ${isPerfect ? "text-emerald-600" : "text-rose-600"}`}>
                  KPI Kesesuaian
                </p>
                <div className="flex items-baseline gap-1.5 mt-0.5">
                  <h3 className={`text-xl font-black ${isPerfect ? "text-emerald-700" : "text-rose-700"}`}>{kpiPercentage}%</h3>
                  <span className={`text-[10px] font-bold px-1.5 py-0.5 rounded-md ${isPerfect ? "text-emerald-600/80 bg-emerald-100" : "text-rose-700 bg-rose-100"}`}>
                    {validItems}/{totalItems} Match
                  </span>
                </div>
              </div>
            </div>
          );
        })()}
</div>

      {/* MAIN DATA TABLE */}
      <div className="bg-white rounded-2xl border border-slate-200/80 shadow-xs overflow-hidden">
        <div className="overflow-x-auto">
          {loading ? (
            <div className="p-12 text-center text-sm text-slate-400 flex flex-col items-center justify-center gap-3">
              <RefreshCw size={24} className="animate-spin text-indigo-500" />
              <span>Memuat data rekonsiliasi split...</span>
            </div>
          ) : (
          <table className="w-full text-left border-collapse text-sm whitespace-nowrap">
  <thead>
    <tr className="bg-slate-100/80 text-slate-500 font-bold border-b border-slate-200 uppercase tracking-wider text-xs">
      <th className="p-4 pl-6">Tanggal</th>
      <th className="p-4 text-center">Qty</th>
      <th className="p-4 text-right">Bruto</th>
      <th className="p-4 text-right text-rose-800">Potongan Diskon</th>
      <th className="p-4 text-right font-bold text-slate-700 bg-slate-50">Netto Penjualan (A)</th>
      {/* 💡 BG Dipertegas menjadi bg-rose-100 tanpa opacity pudar /10 */}
      <th className="p-4 text-right font-bold text-rose-900 bg-rose-100/70 border-x border-rose-200">Cost Tiktok</th>
      <th className="p-4 text-right font-bold text-indigo-600 bg-indigo-50/30">Total Tervalidasi (B)</th>
      <th className="p-4 text-left text-indigo-600 bg-indigo-50/30">Metode Alokasi</th>
      <th className="p-4 text-center pr-6">Status</th>
    </tr>
  </thead>
  <tbody className="divide-y divide-slate-100 font-medium text-slate-700">
    {processedData.length > 0 ? (
      processedData.map((item, idx) => (
        <tr 
          key={idx} 
          onClick={() => handleRowClick(item)}
          className={`hover:bg-indigo-50/30 transition-colors cursor-pointer ${!item.is_valid ? 'bg-amber-50/15' : ''}`}
        >
          <td className="p-4 pl-6 font-semibold text-slate-900">
            {new Date(item.tanggal_penjualan).toLocaleDateString("id-ID", { day: 'numeric', month: 'short', year: 'numeric' })}
          </td>
          <td className="p-4 text-center">{item.qty}</td>
          <td className="p-4 text-right">Rp {item.bruto.toLocaleString("id-ID")}</td>
          <td className="p-4 text-right font-bold text-rose-800">-Rp {item.potongan.toLocaleString("id-ID")}</td>
          <td className="p-4 text-right font-bold text-slate-800 bg-slate-50">Rp {item.netto_penjualan.toLocaleString("id-ID")}</td>
          
          {/* 💡 BG Kolom data Cost Tiktok disesuaikan agar kontras warna teksnya aman dibaca */}
          <td className="p-4 text-right font-bold text-rose-900 bg-rose-100/40 border-x border-rose-100/70">
            Rp {item.cost_tiktok.toLocaleString("id-ID")}
          </td>
          
          <td className="p-4 text-right font-bold text-indigo-600 bg-indigo-50/10">
            Rp {item.total_pembayaran.toLocaleString("id-ID")}
          </td>
          
          {/* RINCIAN METODE SIMPLE */}
          <td className="p-4 text-left font-semibold bg-indigo-50/10">
            {item.detail_pembayaran && item.detail_pembayaran.length > 0 ? (
              item.detail_pembayaran.length === 1 ? (
                <span className="text-slate-700">{item.detail_pembayaran[0].metode}</span>
              ) : (
                <span className="text-indigo-600 bg-indigo-50 border border-indigo-100 px-2 py-0.5 rounded-md text-xs font-bold">
                  {item.detail_pembayaran.length}+ Metode Pembayaran
                </span>
              )
            ) : (
              <span className="text-xs text-rose-400 italic font-normal">Belum dialokasikan</span>
            )}
          </td>

          <td className="p-4 text-center pr-6">
            <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-black uppercase tracking-wider ${
              item.is_valid 
                ? "bg-emerald-50 text-emerald-700 border border-emerald-200" 
                : "bg-rose-50 text-rose-700 border border-rose-200"
            }`}>
              {item.is_valid ? <CheckCircle2 size={13} /> : <XCircle size={13} />}
              {item.status_label}
            </span>
          </td>
        </tr>
      ))
    ) : (
      <tr>
        {/* 💡 FIX: Diubah ke colSpan="9" agar pas dengan total jumlah header di atas */}
        <td colSpan="9" className="p-10 text-center text-slate-400 font-medium bg-white">
          Tidak ada transaksi.
        </td>
      </tr>
    )}
  </tbody>
</table>
          )}
        </div>
      </div>

      {/* ======================================================= */}
      {/* MODAL MULTI-METODE VALIDASI (SPLIT PAYMENT)             */}
      {/* ======================================================= */}
     {selectedRow && (
  <div className="fixed inset-0  bg-slate-900/40  backdrop-blur-sm flex items-center justify-center z-50 p-4">
    {/* 💡 UKURAN MODAL DIPERBESAR KELUAR: dari max-w-lg menjadi max-w-4xl */}
    <div className="bg-white rounded-2xl border border-slate-200 shadow-2xl w-full max-w-4xl overflow-hidden transform transition-all animate-scaleUp">
      
      {/* Modal Header */}
      <div className="p-5 border-b border-slate-100 flex items-center justify-between bg-slate-50">
        <div>
          <h3 className="text-base font-bold text-slate-900">Alokasi & Validasi Metode Bayar</h3>
          <p className="text-xs text-slate-500 mt-0.5">
            Tanggal Buku: {new Date(selectedRow.tanggal_penjualan).toLocaleDateString("id-ID", { day: 'numeric', month: 'long', year: 'numeric' })}
          </p>
        </div>
        <button onClick={() => setSelectedRow(null)} className="text-slate-400 hover:text-slate-600 p-1.5 rounded-lg hover:bg-slate-200/50 transition-colors">
          <X size={18} />
        </button>
      </div>

      {/* Modal Body / Form */}
      {/* 💡 STRUKTUR UTAMA DIUBAH MENJADI GRID 2 KOLOM PADA LAYAR SEDANG KE ATAS */}
      <form onSubmit={handleSaveValidation} className="p-6 grid grid-cols-1 md:grid-cols-12 gap-6 bg-white text-slate-800">
        
        {/* ================= KOLOM KIRI (md:col-span-5): RINGKASAN & VALIDASI ================= */}
        <div className="md:col-span-5 space-y-4 flex flex-col justify-between">
          <div className="space-y-4">
            {/* ─── INDIKATOR BALANCE ─── */}
            <div className={`p-4 rounded-2xl border transition-all duration-300 grid grid-cols-1 gap-3 text-left ${
              currentFormTotal === selectedRow.netto_penjualan 
                ? "bg-emerald-50/60 border-emerald-200/80 ring-4 ring-emerald-50/30" 
                : "bg-slate-50 border-slate-200/80"
            }`}>
              <div className="border-b border-slate-200/60 pb-2 flex justify-between items-center">
                <span className="text-[10px] font-bold text-slate-400 uppercase tracking-wider">Netto Terbayar (A)</span>
                <span className="text-sm font-bold text-slate-700">Rp {selectedRow.netto_penjualan.toLocaleString("id-ID")}</span>
              </div>

               <div className="border-b border-rose-200/60 pb-2 bg-rose-100 flex justify-between items-center">
                <span className="text-[10px] font-bold text-slate-400 uppercase tracking-wider">Cost (C)</span>
                <span className="text-sm font-bold text-slate-700">Rp {selectedRow.cost_tiktok.toLocaleString("id-ID")}</span>
              </div>
              
              <div className="border-b border-slate-200/60 pb-2 flex justify-between items-center">
                <span className="text-[10px] font-bold text-slate-400 uppercase tracking-wider">Total Validasi (B)</span>
                <span className={`text-sm font-bold transition-colors ${
                  currentFormTotal === selectedRow.netto_penjualan ? "text-emerald-600 font-extrabold" : "text-indigo-600"
                }`}>
                  Rp {currentFormTotal.toLocaleString("id-ID")}
                </span>
              </div>

              <div className="flex justify-between items-center pt-0.5">
                <span className="text-[10px] font-bold text-slate-400 uppercase tracking-wider">Selisih Balans</span>
                <span className={`text-sm font-black transition-colors ${
                  selectedRow.netto_penjualan + selectedRow.cost_tiktok - currentFormTotal === 0 ? "text-emerald-600" : "text-rose-500"
                }`}>
                  {selectedRow.netto_penjualan + selectedRow.cost_tiktok - currentFormTotal === 0 ? "✔ Match" : `Rp ${(selectedRow.netto_penjualan + selectedRow.cost_tiktok - currentFormTotal).toLocaleString("id-ID")}`}
                </span>
              </div>
            </div>

            {/* ─── STATUS VALIDASI & INFORMASI POSTING ─── */}
            <div>
              {currentFormTotal === selectedRow.netto_penjualan+ selectedRow.cost_tiktok ? (
                <div className="bg-emerald-50 text-emerald-900 p-3.5 rounded-2xl text-xs border border-emerald-100/80 space-y-1 shadow-2xs">
                  <div className="flex items-center gap-1.5 font-bold text-emerald-800">
                     <span>✔</span> Sesuai & Siap Posting
                  </div>
                  <p className="text-slate-600 font-normal leading-relaxed text-[11px]">
                    Validasi ini akan disimpan secara permanen ke dalam sistem EDP & keuangan.
                  </p>
                </div>
              ) : (
                <div className="bg-rose-50 text-rose-900 p-3 rounded-xl text-xs font-medium border border-rose-100 flex items-center gap-2">
                  <span className="text-rose-500 font-bold">⚠</span> 
                  <span className="text-[11px] text-slate-600">Pecahan belum sama dengan Target Netto.</span>
                </div>
              )}
            </div>

            {/* ─── CHECKBOX KONFIRMASI AKUN ─── */}
            {currentFormTotal === selectedRow.netto_penjualan + selectedRow.cost_tiktok && (
              <div className="bg-slate-50 border border-slate-200/60 p-3.5 rounded-2xl space-y-2.5 shadow-2xs">
                <div className="text-[10px] text-slate-400 font-bold uppercase tracking-wider">
                  Penanggung Jawab: <span className="font-extrabold text-slate-700 bg-slate-200/60 px-1.5 py-0.5 rounded-md ml-1">{userName}</span>
                </div>
                <label className="flex items-start gap-3 cursor-pointer select-none group">
                  <input 
                    type="checkbox" 
                    checked={isChecked}
                    onChange={(e) => setIsChecked(e.target.checked)}
                    className="mt-0.5 rounded border-slate-300 text-indigo-600 focus:ring-indigo-500 h-4 w-4 cursor-pointer transition-all"
                  />
                  <span className="text-xs text-slate-600 leading-tight group-hover:text-slate-800 transition-colors">
                    Saya bertanggung jawab penuh atas keabsahan data validasi ini.
                  </span>
                </label>
              </div>
            )}
          </div>

          {/* ─── AKSI TRIGGER BUTTONS (Di bawah kolom kiri) ─── */}
          <div className="flex items-center gap-3 pt-4 border-t border-slate-100 mt-4 md:mt-0">
            <button
              type="button"
              onClick={() => {
                setSelectedRow(null);
                setIsChecked(false);
              }}
              className="w-1/2 h-10 border border-slate-200 hover:bg-slate-50 text-slate-500 hover:text-slate-700 rounded-xl text-xs font-bold transition-all"
            >
              Batal
            </button>
            <button
              type="submit"
              disabled={isSubmitting || currentFormTotal !== selectedRow.netto_penjualan + selectedRow.cost_tiktok || !isChecked}
              className="w-1/2 h-10 bg-indigo-600 hover:bg-indigo-700 disabled:opacity-35 disabled:pointer-events-none text-white rounded-xl text-xs font-bold shadow-md shadow-indigo-600/10 flex items-center justify-center transition-all cursor-pointer"
            >
              {isSubmitting ? "Menyimpan..." : "Simpan Validasi"}
            </button>
          </div>
        </div>

        {/* ================= KOLOM KANAN (md:col-span-7): LIST INPUT METODE & UPLOAD ================= */}
        <div className="md:col-span-7 border-l-0 md:border-l md:border-slate-100 md:pl-6 space-y-3">
  <div className="flex items-center justify-between sticky top-0 bg-white pb-1 z-10">
    <label className="text-xs font-bold text-slate-500 uppercase tracking-wider">Rincian Pembayaran</label>
    <span className="text-[11px] bg-slate-100 text-slate-600 px-2 py-0.5 rounded-md font-semibold">{formSplits.length} Metode</span>
  </div>
  
  {/* Container Scroll Internal Baris Item */}
  <div className="space-y-3 max-h-[22rem] overflow-y-auto pr-1.5 scrollbar-thin scrollbar-thumb-slate-200">
    {formSplits.length > 0 ? (
      formSplits.map((split, index) => {
        const isMethodSelected = split.metode !== "";
        
        // 💡 UX LOCK: Deteksi jika baris ini merupakan metode Tiktok (Abaikan besar/kecil huruf)
        const isTiktok = split.metode?.toLowerCase() === "tiktok";

        return (
          <div 
            key={index} 
            className={`p-3.5 rounded-xl border transition-all duration-200 space-y-3 ${
              isTiktok
                ? "bg-slate-100/70 border-slate-300 shadow-2xs select-none" // Style khusus baris default tiktok
                : split.file_bukti 
                  ? "bg-white border-emerald-200/70 shadow-xs ring-2 ring-emerald-500/5" 
                  : "bg-slate-50/60 border-slate-200/60 hover:border-slate-300"
            }`}
          >
            {/* Baris Utama: Dropdown & Input */}
            <div className="flex items-center gap-2.5">
              <div className="w-5/12">
                <select
                  value={split.metode}
                  onChange={(e) => handleSplitChange(index, "metode", e.target.value)}
                  // 💡 LOCK DROPDOWN: Kunci jika baris bawaan Tiktok
                  disabled={isTiktok}
                  className={`w-full h-10 px-3 border border-slate-200 rounded-xl text-xs font-semibold shadow-xs transition-all outline-none ${
                    isTiktok 
                      ? "bg-slate-200 text-slate-500 cursor-not-allowed border-slate-300" 
                      : "bg-white text-slate-800 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100 cursor-pointer"
                  }`}
                  required
                >
                  <option value="" disabled>-- Pilih Metode --</option>
                  {paymentMethods.map((pm, pmIdx) => (
                    <option key={pmIdx} value={pm.name}>{pm.name}</option>
                  ))}
                </select>
              </div>

              <div className="w-6/12 relative flex items-center">
                <span className="absolute left-3 text-xs font-bold text-slate-400 select-none">Rp</span>
                <input
                  type="number"
                   disabled={isTiktok}
                  value={split.nominal || ""}
                  onChange={(e) => handleSplitChange(index, "nominal", e.target.value)}
                  placeholder="Nominal"
                  className="w-full h-10 pl-9 pr-3 border border-slate-200 rounded-xl text-xs font-bold text-slate-800 shadow-xs focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100 transition-all outline-none"
                  required
                />
              </div>

              {/* 💡 LOCK TOMBOL HAPUS: Sembunyikan tombol hapus jika baris Tiktok */}
              <div className="w-[10%] flex justify-center">
                {!isTiktok ? (
                  <button
                    type="button"
                    onClick={() => handleRemoveSplitRow(index)}
                    className="p-2.5 text-slate-400 hover:text-rose-500 hover:bg-rose-50 rounded-xl transition-all flex-shrink-0"
                    title="Hapus"
                  >
                    <Trash2 size={16} />
                  </button>
                ) : (
                  // Pengganti ruang kosong agar layout tombol konsisten
                  <span className="text-[10px] text-slate-400 font-bold bg-slate-200 px-1.5 py-1 rounded-md" title="Metode Utama Instansi">
                    Lock
                  </span>
                )}
              </div>
            </div>

            {/* 💡 LOCK UPLOAD BUKTI: Hanya tampil jika metode BUKAN Tiktok */}
            {!isTiktok && (
              <div className="pl-0.5 animate-fadeIn">
                <input
                  type="file"
                  id={`bukti-${index}`}
                  accept="image/*,application/pdf"
                  onChange={(e) => handleSplitChange(index, "file_bukti", e.target.files[0])}
                  className="hidden"
                  disabled={!isMethodSelected}
                  required={isMethodSelected}
                />
                
                {split.file_bukti ? (
                  <div className="flex items-center justify-between bg-emerald-50/70 border border-emerald-200 rounded-xl px-3 py-2 w-full text-xs text-emerald-800 font-medium">
                    <div className="flex items-center gap-2 truncate max-w-[80%]">
                      <FileCheck size={15} className="text-emerald-600 flex-shrink-0" />
                      <span className="truncate text-[11px]">{split.nama_file_bukti}</span>
                    </div>
                    <button 
                      type="button" 
                      onClick={() => handleSplitChange(index, "file_bukti", null)}
                      className="text-rose-600 font-bold text-[11px] hover:text-rose-700 hover:underline bg-white px-2 py-1 rounded-lg border border-rose-100 shadow-2xs transition-all"
                    >
                      Ganti
                    </button>
                  </div>
                ) : (
                  <label
                    htmlFor={`bukti-${index}`}
                    className={`flex items-center justify-center gap-2 border border-dashed rounded-xl h-9 w-full text-[11px] font-bold transition-all ${
                      isMethodSelected 
                        ? "border-indigo-300 bg-indigo-50/30 text-indigo-600 hover:bg-indigo-50/60 hover:border-indigo-400 cursor-pointer shadow-2xs" 
                        : "border-slate-200 bg-slate-100/50 text-slate-400 cursor-not-allowed select-none"
                    }`}
                  >
                    <Upload size={13} className={isMethodSelected ? "animate-bounce" : ""} /> 
                    {isMethodSelected ? `Upload Bukti Settlement (${split.metode})` : "Pilih Metode Terlebih Dahulu"}
                  </label>
                )}
              </div>
            )}
          </div>
        );
      })
    ) : (
      <div className="text-center py-6 text-xs text-slate-400 italic bg-slate-50/50 rounded-2xl border-2 border-dashed border-slate-200/60">
        Belum ada metode dialokasikan. Silakan klik tambah di bawah.
      </div>
    )}
  </div>

  {/* Tombol Tambah Row */}
  <button
    type="button"
    onClick={handleAddSplitRow}
    className="w-full h-10 border-2 border-dashed border-slate-200 text-slate-500 hover:text-indigo-600 hover:border-indigo-300 hover:bg-indigo-50/10 rounded-xl text-xs font-bold flex items-center justify-center gap-2 transition-all bg-white shadow-2xs"
  >
    <Plus size={15} /> Tambah Metode Pembayaran Lain
  </button>
</div>

      </form>
    </div>
  </div>
)}

    </div>
  );
}